let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dA1E5"), load("cPaXL")]).then(() => parcelRequire('v2hhG'));